import "./Btn.css";

export default function Btn(props) {
  return (
    <div>
      <button type="button" className="btn">
        {props.title}
      </button>
    </div>
  );
}
